module.exports = __webpack_public_path__ + "static/media/button_play_store.38c33191.png";